module.exports = __webpack_public_path__ + "img/OnSpécifique lumière écran.f0c12fe6.gif";